<template>
  <div>
    <slot name="badges"></slot>
    <slot name="badges-spoiler" v-if="show"></slot>
    <a
      class="badge badge-spoiler mx-1 m-1 badge-light"
      style="cursor: pointer"
      @click="show = !show"
      v-if="!!this.$slots['badges-spoiler']"
    >
      <i
        v-if="!show"
        class="icon icon-overflow-menu-horizontal"
        style="font-size: 16px, font-weight: bold;"
      ></i>
      <i 
        v-if="show" 
        class="icon icon-undo" 
        style="font-size: 16px, font-weight: bold;"
      ></i>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style>
</style>
